module.exports = __webpack_public_path__ + "img/warning.e2c09ed1.svg";